/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Theme info in console
// console.log('Custom Shopify Theme Developed By EcomGraduates LLC | https://www.ecomgraduates.com')
function logCredits() {
  const style = `
    display: inline-block;
    font-size: 14px;
    background: linear-gradient(90deg, rgba(185,61,244,1) 0%, rgba(219,33,153,1) 46%, rgba(250,5,64,1) 100%) !important;
    color: white;
    padding: 4px;
    border-radius: 4px;
  `;
  let message = `
    📈 Increased conversion rates
    📈 Increased average order value
    📈 Increased customer lifetime value
    📈 Best support for your success

    Learn more at: https://ecomgraduates.com
  `;
  console.group("%c🎓 Custom Shopify Theme by EcomGraduates. 🎓", style);
  console.log(`%c${message}`, "font-size: 14px;");
  console.groupEnd();
}
logCredits();

// Offcanvas menu
const offcanvasMenu = document.querySelector('#offcanvas-menu');

if (offcanvasMenu) {
    offcanvasMenu.addEventListener('shown.bs.offcanvas', event => {
        document.querySelector('[href="#offcanvas-menu"] .svg-icon-menu')?.setAttribute('hidden', 'hidden');
        document.querySelector('[href="#offcanvas-menu"] .svg-icon-close')?.removeAttribute('hidden');
    });

    offcanvasMenu.addEventListener('hidden.bs.offcanvas', event => {
        document.querySelector('[href="#offcanvas-menu"] .svg-icon-menu')?.removeAttribute('hidden');
        document.querySelector('[href="#offcanvas-menu"] .svg-icon-close')?.setAttribute('hidden', 'hidden');
    });
}

// Quantity steppers (plus/minus)
window.onClickQtyPlusMinus = (btn) => {
    const wrapper = btn.closest('.quantity-wrapper');
    if (!wrapper) return;

    const input = wrapper.querySelector('input');
    if (!input) return;

    const inputValue = Number(input.value);

    if (btn.dataset.mode === 'plus') {
        input.value = inputValue + 1;
    } else {
        if (input.value > Number(input.dataset.minQty)) {
            input.value = inputValue - 1;
        }
    }

    const event = new Event('change');
    input.dispatchEvent(event);
};

// Share links using WebShare API
window.onLinkShare = (btn, e) => {
    if (navigator.share) {
        navigator.share({
            title: btn.dataset.shareTitle,
            url: window.location.href
        });
    } else {
        const popover = bootstrap.Popover.getOrCreateInstance(btn, {
            content: `
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" value="${window.location.href}">
                    <button id="btn-share-copy" class="btn btn-outline-secondary" type="button">${btn.dataset.textCopy}</button>
                </div>
            `,
            html: true,
            sanitize: false,
            placement: 'top'
        });

        popover.show();

        document.querySelector('#btn-share-copy')?.addEventListener('click', (e) => {
            navigator.clipboard.writeText(window.location.href);
            e.target.textContent = btn.dataset.textCopied;
        });

        setTimeout(() => {
            popover.hide();
            btn.blur();
        }, 4000);
    }
};

// Search page - set selected value for the types select field
const initSearchPageSetSelected = () => {
    const select = document.querySelector('#search-header .form-select');

    if (!select) return;

    const params = new URLSearchParams(location.search);
    const type = params.get('type');

    if (!type) return;

    select.value = type;
};
initSearchPageSetSelected();

// Countdown timers
const initCountdownTimers = () => {
    document.querySelectorAll('.countdown-timer').forEach((elem) => {
        if (elem.classList.contains('init')) return;

        elem.classList.add('init');

        let end = Number(elem.dataset.time) * 1000;

        if (window.location.href.includes('ecomify')) {
            end = Date.now() + 1.08e+7;
        }

        const seconds = 1000;
        const minutes = seconds * 60;
        const hours = minutes * 60;

        const x = setInterval(() => {
            const now = new Date().getTime();
            const difference = end - now;

            if (difference < 0) {
                clearInterval(x);
                elem.remove();
                return;
            }

            elem.removeAttribute('hidden');

            const h = Math.floor((difference) / hours);
            const m = Math.floor((difference % hours) / minutes);
            const s = Math.floor((difference % minutes) / seconds);

            const hoursElem = elem.querySelector('[data-hours]');
            const minutesElem = elem.querySelector('[data-minutes]');
            const secondsElem = elem.querySelector('[data-seconds]');

            if (!hoursElem || !minutesElem || !secondsElem) return;

            hoursElem.innerText = `${h}${elem.dataset.textH}`;
            hoursElem.setAttribute('aria-label', `${h} ${elem.dataset.textHours}`);
            minutesElem.innerText = `${m}${elem.dataset.textM}`;
            minutesElem.setAttribute('aria-label', `${m} ${elem.dataset.textMinutes}`);
            secondsElem.innerText = `${s}${elem.dataset.textS}`;
            secondsElem.setAttribute('aria-label', `${s} ${elem.dataset.textSeconds}`);

            if (h === 0) {
                hoursElem.setAttribute('hidden', 'hidden');
            }
        }, seconds);
    });
};
initCountdownTimers();

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.countdown-timer')) {
        initCountdownTimers();
    }
});
